import "twin.macro";

import { Skeleton, TableBody, TableCell, TableRow } from "@mui/material";

const OrderSetOrdersSkeleton = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => {
  return (
    <TableBody>
      {Array.from({ length: Math.min(height, 10) }).map((_, i) => (
        <TableRow key={i}>
          <TableCell>
            <Skeleton variant="text" />
          </TableCell>
          {Array.from({ length: Math.min(width, 10) }).map((_, j) => (
            <TableCell key={j}>
              <Skeleton variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default OrderSetOrdersSkeleton;
